import { render, staticRenderFns } from "./ChangeTagsReal.vue?vue&type=template&id=8d2bfef8&scoped=true&"
import script from "./ChangeTagsReal.vue?vue&type=script&lang=js&"
export * from "./ChangeTagsReal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTagsReal.vue?vue&type=style&index=0&id=8d2bfef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2bfef8",
  null
  
)

export default component.exports